<template>
  <div class="fazp-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="客户名称"
                    width="160"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.all_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="指派状态"
                    width="120"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.assignmark===0" :disable-transitions="true" size="mini" type="danger">未指派</el-tag>
                      <el-tag v-if="scope.row.assignmark===1" :disable-transitions="true" size="mini" type="warning">部分指派</el-tag>
                      <el-tag v-if="scope.row.assignmark===2" :disable-transitions="true" size="mini">已指派</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="目前阶段"
                    width="140"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.stage_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="周期"
                    min-width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.start_time }} ～ {{ scope.row.end_time }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="方案指派详情"
      :visible.sync="editVisible"
      top="10vh"
      width="35%"
    >
      <div v-loading="dloading">
        <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="auto" size="small">
          <el-form-item label="客户全称" prop="delname">
            <el-input
              v-model="editForm.delname"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="方案周期" prop="time">
            <el-input
              v-model="editForm.time"
              prefix-icon="el-icon-date"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
          <div v-for="(item, index) in editForm.planInfo" :key="item.key">
            <el-form-item :label="item.stagename" :prop="'planInfo.' + index +'.userid'">
              <div style="position: absolute">
                <i v-if="item.icon===0" class="el-icon-remove-outline" style="color:#99a9bf"></i>
                <i v-if="item.icon===1" class="el-icon-time" style="color:#E6A23C"></i>
                <i v-if="item.icon===2" class="el-icon-success" style="color:#67C23A"></i>
              </div>
              <UserSelect v-model="item.userid" :set="item.userid" :userid="user.dUserid" :tcfstyle="'padding-left:24px;width:100%;'" :disabled="item.mark===1"></UserSelect>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="editLoading" @click="submitForm('editForm')">立即提交</el-button>
        <el-button size="small" @click="editVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getExProgramList, getExAssignDetail, addOrEditExAssign } from '@/api/work'
import UserSelect from '@/components/UserSelect'

export default {
  name: 'Fazp',
  components: {
    UserSelect
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      dloading: false,
      editLoading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editForm: {
        exid: null,
        delname: '',
        time: '',
        planInfo: []
      },
      editRules: {
        time: [{ required: true, message: '请选择', trigger: 'blur' }],
        delname: [{ required: true, message: '请选择客户', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search != null && this.searchForm.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid
      }
      getExProgramList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.editForm.exid = row.ex_id
      this.editForm.delname = row.all_name
      this.editForm.time = row.start_time + ' ~ ' + row.end_time
      this.editForm.planInfo = []
      this.editVisible = true
      this.dloading = true
      getExAssignDetail({ exid: this.editForm.exid }).then(response => {
        this.editForm.starttime = response.data.startTime
        this.editForm.endtime = response.data.endTime
        const plan = []
        let n = 0
        for (const p of response.data.stageList) {
          let userid = null
          if (p.user_id !== null && p.user_id !== 0) {
            userid = p.user_id
          }
          let icon = 0
          if (p.mark === 1) {
            icon = 2
          } else {
            if (n === 0) {
              icon = 1
              n = 1
            }
          }
          plan.push({ stageid: p.stage_id, stagename: p.stage_name, icon: icon, username: p.user_name, userid: userid, mark: p.mark })
        }
        this.editForm.planInfo = plan
        this.dloading = false
      }).catch(() => {
        this.dloading = false
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editLoading) {
            this.editLoading = true
            let jsonStr = ''
            for (const p of this.editForm.planInfo) {
              jsonStr += '"' + p.stageid + '":"' + p.userid + '",'
            }
            if (jsonStr.length > 0) {
              jsonStr = '{' + jsonStr.substring(0, jsonStr.length - 1) + '}'
            }
            const data = {
              exid: this.editForm.exid,
              jsonStr: jsonStr,
              userid: this.user.dUserid
            }
            addOrEditExAssign(data).then(response => {
              this.$message({
                message: '方案指派提交成功',
                type: 'success'
              })
              this.editLoading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.editLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fazp-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
